import React, { Suspense } from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import ArticleBlock from '../../adapters/helpers/ArticleBlock';
const BiographyContent = dynamic(() => import('../BiographyContent/BiographyContent'));
import Loader from '../../adapters/helpers/Loader';
import LazyLoad from 'react-lazy-load';
export default function ArticleBody(props) {
  var _extraAttributes$enti, _articleBlock$article, _articleBlock$article2, _articleBlock$article3;
  const extraAttributes = props.extraAttributes || {};
  const article = extraAttributes.entity;
  const classAttribute = (_extraAttributes$enti = extraAttributes.entity) == null ? void 0 : _extraAttributes$enti.className;
  const articleBlock = new ArticleBlock({
    document: props.document,
    article
  });
  const children = articleBlock.renderChildBlocks({
    extraAttributes
  }, props.onClickCallback, props.customEvent);
  const biographyContent = (articleBlock == null ? void 0 : (_articleBlock$article = articleBlock.article) == null ? void 0 : (_articleBlock$article2 = _articleBlock$article.biographyContent) == null ? void 0 : _articleBlock$article2.fields) || null;
  const biographyModalArticleList = (articleBlock == null ? void 0 : (_articleBlock$article3 = articleBlock.article) == null ? void 0 : _articleBlock$article3.articleListsForBiographyModal) || null;
  return <div className={`ob-article-body ${classAttribute}`}>
        <LazyLoad offset={100}>
        <Suspense fallback={<Loader />}>
        {children}
        </Suspense>
        </LazyLoad>
        <React.Fragment>{biographyContent && <BiographyContent biographyContent={biographyContent} biographyModalArticleList={biographyModalArticleList} />}</React.Fragment>
    </div>;
}
ArticleBody.propTypes = {
  className: PropTypes.string,
  extraAttributes: PropTypes.object,
  document: PropTypes.object,
  onClickCallback: PropTypes.func,
  customEvent: PropTypes.object
};